// Shared constants for the mismatch correction UI.
export const CORRECTABLE = ["no_polisi", "jumlah", "nama_barang", "no_so", "distrik", "tanggal"];

export const FIELD_LABEL = {
  no_polisi: "No Polisi",
  jumlah: "Jumlah",
  nama_barang: "Nama Barang",
  no_so: "No SO",
  distrik: "Distrik",
  tanggal: "Tanggal",
};
